import React, { useEffect, useState } from "react";
import Navbar from "../../../Shared/Navbar/Navbar";
import Sidebar from "../../../Shared/Sidebar";
import Preloader from "../../../Shared/Preloader/Preloader";
import LessSidebar from "../../../Shared/LessSidebar";
import { currentUser } from "../../../../authentication/auth";
import { useNavigate } from "react-router-dom";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import LaboratoryService from "../../../services/LaboratoireService";
import Kanban from "./Kanban";
export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [user, setUser] = useState();

  const getAgents = async () => {
    setLoading(true);

    try {
      const response = await LaboratoryService.agentsAll();
      if (response.status === 200) {
        setLoading(false);
        setAgents(response.data.data);
      }
    } catch (err) {
      setLoading(false);
      // console.log(err);
    }
  };

  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
      getAgents();
    }
  }, []);
  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar user={user} pageName={"by Agent"} icon={faBriefcase} />
        <hr />
        <Kanban agents={agents} />
      </main>
    </>
  );
}
